import Require2FA from './Require2FA';

export default Require2FA;
